import { Box } from "@mui/material";

export const BookingConfirmationPage = () => {
  return <Box></Box>;
};
